import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";

type props = {
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  text: string;
  handleSubmit: () => void;
};
export const ConfirmationModal = ({
  openModal,
  setOpenModal,
  text,
  handleSubmit,
}: props) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#ffff",
    // border: "1px solid #fff",
    boxShadow: 24,
    p: 6,
    borderRadius: 3,
    outline: "none",
  };
  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="modal addCategory_modal"
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2> {text}</h2>
          </div>

          <div className="footer_btn_flex">
            <Button
              className="btn btn_grey"
              onClick={() => setOpenModal(false)}
            >
              No
            </Button>
            <Button
              className="btn btn_primary"
              onClick={() => {
                setOpenModal(false);
                handleSubmit();
              }}
            >
              Yes
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
